import React from "react";
import { Box, Button, Tooltip } from "@material-ui/core";
import {
  Edit,
  Delete,
  Visibility,
  CheckCircle,
  Equalizer,
  TurnedIn,
  GroupAdd,
  Block,
  RateReview,
  PanTool,
  Gavel,
  Update,
  ExitToApp,
} from "@material-ui/icons";

// ActionButton mới (refactor 2026-05-15) — đồng bộ với SR pattern.
// Mỗi key map → 1 icon + tooltip; mở modal qua setOpen({ [key]: true }).
const ACTION_MAP = {
  detail:                  { tooltip: "Chi tiết",                       icon: <Visibility fontSize="small" />, color: "primary" },
  edit:                    { tooltip: "Chỉnh sửa",                      icon: <Edit fontSize="small" />,        color: "primary" },
  delete:                  { tooltip: "Xoá",                            icon: <Delete fontSize="small" />,      className: "error-button" },

  // Đăng ký
  submitRegistration:      { tooltip: "Nộp đăng ký",                    icon: <ExitToApp fontSize="small" />,   className: "success-button" },
  reviewByMod:             { tooltip: "Duyệt vòng đơn vị",              icon: <RateReview fontSize="small" />,  className: "success-button" },
  reviewByAdmin:           { tooltip: "Duyệt vòng Phòng QLKH",          icon: <CheckCircle fontSize="small" />, className: "success-button" },

  // Hội đồng (3 vòng)
  selectionCouncil:        { tooltip: "Gán Hội đồng tuyển chọn",        icon: <GroupAdd fontSize="small" />,    className: "success-button" },
  reviewSelectionCouncil:  { tooltip: "Cập nhật kết quả HĐ tuyển chọn", icon: <Gavel fontSize="small" />,       className: "success-button" },
  midtermCouncil:          { tooltip: "Gán Hội đồng tiến độ",           icon: <GroupAdd fontSize="small" />,    className: "success-button" },
  reviewMidtermCouncil:    { tooltip: "Cập nhật kết quả HĐ tiến độ",    icon: <Gavel fontSize="small" />,       className: "success-button" },
  finalCouncil:            { tooltip: "Gán Hội đồng nghiệm thu",        icon: <GroupAdd fontSize="small" />,    className: "success-button" },
  reviewFinalCouncil:      { tooltip: "Cập nhật kết quả nghiệm thu",    icon: <Gavel fontSize="small" />,       className: "success-button" },

  // Báo cáo
  progressReport:          { tooltip: "Nộp Báo cáo tiến độ (2y)",       icon: <Equalizer fontSize="small" />,   className: "success-button" },
  finalReport:             { tooltip: "Nộp Báo cáo tổng kết",           icon: <TurnedIn fontSize="small" />,    className: "success-button" },

  // Xin dừng / gia hạn
  requestStop:             { tooltip: "Xin dừng thực hiện",             icon: <PanTool fontSize="small" />,     color: "secondary" },
  reviewStop:              { tooltip: "Duyệt đơn xin dừng",             icon: <Block fontSize="small" />,       color: "secondary" },
  requestExtension:        { tooltip: "Xin gia hạn (1y, +6 tháng)",     icon: <Update fontSize="small" />,      color: "secondary" },
  reviewExtension:         { tooltip: "Duyệt đơn xin gia hạn",          icon: <CheckCircle fontSize="small" />, color: "secondary" },

  disabled:                { tooltip: "—",                               icon: <Visibility style={{ color: "#ffffff00" }} fontSize="small" />, color: "primary" },
};

function ActionButton({ actions, row, setOpen, setDetail }) {
  if (!actions || actions.length === 0) return null;

  const handleClick = (key) => {
    if (key === "detail") {
      const parent = row?.parentResearch;
      if (parent) {
        setDetail({ ...row, parentResearch: parent });
      } else {
        setDetail({ ...row });
      }
    } else {
      setDetail({ ...row });
    }
    setOpen({ [key]: true });
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gridGap={6}>
      {actions.map((key, idx) => {
        const meta = ACTION_MAP[key] || ACTION_MAP.detail;
        const disabled = key === "disabled";
        const btn = (
          <Button
            variant="contained"
            color={meta.color || "primary"}
            className={meta.className}
            disabled={disabled}
            style={{ width: 40, minWidth: 40, height: 32, padding: 0 }}
            onClick={() => !disabled && handleClick(key)}
          >
            {meta.icon}
          </Button>
        );
        return (
          <React.Fragment key={`act-${key}-${idx}`}>
            {disabled ? btn : <Tooltip title={meta.tooltip}>{btn}</Tooltip>}
          </React.Fragment>
        );
      })}
    </Box>
  );
}

export default ActionButton;
